const stage = "Prod";

export const FUSE_ARD_SERVICE_V2_ENDPOINT =
  String(stage) === "Prod"
    ? "https://nja07m327i.execute-api.us-west-2.amazonaws.com/Prod-FE/"
    : "https://9icnssdy85.execute-api.us-west-2.amazonaws.com/Beta/";
